<div @swipeAnimation *ngIf="showComponent">
  <ng-container *ngIf="(proposal|async) as proposal; else loading">
    <ng-container
      *ngIf="{current: (selectedTab$|async)?.[1] , previous:(selectedTab$|async)?.[0]} as selectedTab;">
      <div class="header-preview-container" *ngIf="currentHeader != Header.none "
           [style]="'width: '+tabBar.getBoundingClientRect().width + 'px;'">
        <div class="header-inner-container w-100">
          <div #header *ngIf="currentHeader >= Header.title " class="d-flex justify-content-between title-header">
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          </div>
          <ng-container *ngIf="currentHeader >= Header.tabs">
            <hr class="mb-0">
            <ng-container *ngTemplateOutlet="tabBarTemplate"></ng-container>
          </ng-container>
          <hr class="mb-0">
        </div>
      </div>
      <div id="proposal-details-body" class="d-flex flex-column vh-100">
        <ng-scrollbar visibility="hover">
          <div
            class="pt-3 d-flex min-vh-100 flex-column h-100 top-main-container">
            <div #title>
              <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
            </div>
            <div class="d-flex flex-shrink-1 flex-row main-container">
              <div id="proposal-details-tabs"
                   class=" d-flex flex-column flex-grow-1 flex-shrink-1 left-container">
                <app-proposal-tile [detailsTile]="true"
                                   [proposalTile]="(proposalTile|async)"
                                   [isPreview]="true"
                                   class="w-100"></app-proposal-tile>
                <hr>
                <div #tabBar>
                  <ng-container *ngTemplateOutlet="tabBarTemplate"></ng-container>
                  <hr class="mb-0 mt-3">
                </div>
                <div class="w-100 h-100 body-container mt-4">
                  <div [class.selected]="(selectedTab?.current) === Tab.DETAILS"
                       [class.previously-selected]="(selectedTab?.previous)=== Tab.DETAILS"
                       class="overflow-hidden"
                       label="Details">
                    <app-proposal-details-expandable
                      [(allDetailsOpen)]="allDetailsOpen"
                      [isPreview]="true"></app-proposal-details-expandable>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </ng-scrollbar>
      </div>

      <ng-template #tabBarTemplate>
        <div class="tabBar d-flex gap-4 z-index-4">
          <button (click)="changeTab(Tab.DETAILS) "
                  [class.selected]="(selectedTab?.current)==Tab.DETAILS"
                  class="detail-page-tab-button">
            {{'proposalPreview.tab.details' | translate}}
          </button>
        </div>
      </ng-template>
      <ng-template #titleTemplate>
        <div class="d-flex flex-row justify-content-between title-container">
          <div class="d-flex flex-column">
            <div class="proposal-preview-title">{{'proposalPreview.title' | translate}}
              <ng-container *ngIf="proposal?.partner.name as partnerName"> - {{partnerName}}</ng-container>
            </div>
            <div class="proposal-preview-subtitle">{{'proposalPreview.subtitle'|translate}}</div>
          </div>

          <ng-template [ngIf]="isEditRoute" [ngIfElse]="createButtons">
            <div class="d-flex justify-content-end align-items-end buttons-container">
              <button class="menu-button save-proposal-button cursor-pointer ms-4"
                  (click)="cancel()">
                {{'proposalPreview.cancel' | translate}}
              </button>
              <button class="save-button menu-button save-proposal-button cursor-pointer ms-4"
                      (click)="openConfirmationMatDialog()">
                {{'proposalPreview.saveEdit' | translate}}
              </button>
            </div>
          </ng-template>

          <ng-template #createButtons>
            <ng-container>
              <div class="d-flex justify-content-end align-items-end buttons-container">
                <button class="menu-button save-proposal-button cursor-pointer ms-4"
                        (click)="navigateToCreateProposal()">
                  {{'proposalPreview.back' | translate}}
                </button>
                <button class="save-button menu-button save-proposal-button cursor-pointer ms-4"
                        (click)="openConfirmationMatDialog()">
                  {{'proposalPreview.saveProposal' | translate}}
                </button>
              </div>
            </ng-container>
          </ng-template>



        </div>
      </ng-template>
    </ng-container>

  </ng-container>
</div>

<ng-template #loading >
  <div class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>


